import { Pipe, PipeTransform } from '@angular/core';
import { maskCNPJ, onlyNumbers } from '../helpers/string-helpers';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Pipe({
  standalone: true,
  name: 'moneyFormatPipe'
})
export class MoneyFormatPipe implements PipeTransform {
  constructor(private companyConfig: ConfigurationService,) {

  }
  transform(value: number): string {
    return this.companyConfig.formatNumberByCountry(value);
  }
}
